<template>
  <div class="app-container">
    <navigation title="我的收藏"></navigation>
    <div class="list">
      <div class="content">
        <van-cell-group>
          <van-cell title="" class="list-title" v-if="list.length!==0" :clickable="false">
            <template #right-icon v-if="ifManagement">
              <span class="management" @click="onManagement">管理</span>
            </template>
            <template #right-icon v-else>
              <span class="del" @click="del">删除</span>
              <span class="cal" @click="onCal">取消</span>
            </template>
          </van-cell>
        </van-cell-group>
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
          v-if="isShow"
        >
          <van-checkbox-group v-model="choose">
            <van-cell-group>
              <van-cell :clickable="false" v-for="(item,index) in list" clickable  @click="toggle(index,item.module,item.resourceId)">
                <template #title>
                  <van-checkbox
                    ref="checkboxes"
                    v-if="checkAll"
                    :name="item"
                    checked-color="#d72422"
                    icon-size="14px"
                    class="checkbox"
                  ></van-checkbox>
                  <span class="title-size">{{item.title}}</span>
                </template>
                <template #label>
                  <span class="time">{{ item.updateTime }}</span>
                  <span class="module">{{ item.module }}</span>
                </template>
              </van-cell>
            </van-cell-group>
          </van-checkbox-group>
        </van-list>
        <div v-else class="no-list">
          <img src="@/assets/img/no-collection.png" alt="">
          <p>去收藏你喜欢的内容吧</p>
        </div>
      </div>
    </div>
    <scroll></scroll>
    <version></version>
  </div>
</template>

<script>
import Vue from 'vue'
import {Cell, CellGroup, List, Icon, Checkbox, CheckboxGroup, Toast} from 'vant'
import navigation from '../../components/navigation'
import version from '../../components/version'
import {request} from '../../untils/request'
import scroll from '../../components/scroll'

Vue.use(Cell).use(CellGroup).use(List).use(Icon).use(Checkbox).use(CheckboxGroup)
export default {
  name: 'collection',
  components: {navigation, version,scroll},
  data () {
    return {
      list: [],
      loading: false,
      finished: false,
      checked: true,
      choose: [],
      checkAll: false,
      ifManagement: true,
      params: {
        uid: this.$store.state.uid,
        pageNum: '1',
        pageSize: '10'
      },
      isShow: true
    }
  },
  created () {
    window.scroll(0, 0)
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    },
    onLoad () {
      request('get', '/nlc-web/api/collect', this.params).then(res => {
        console.log('我的收藏', res)
        for(let i=0;i< res.data.content.length;i++){
          this.list.push(res.data.content[i])
        }
        if(this.list.length === 0){
          this.isShow = false
        }
        // 加载状态结束
        this.loading = false
        if (res.data.totalElements === this.list.length) {
          this.finished = true
        }
      })
      this.params.pageNum++
    },
    onManagement () {
      this.checkAll = true
      this.ifManagement = false
    },
    toggle (index,module,id) {
      if(this.checkAll){
        this.$refs.checkboxes[index].toggle()
      } else {
        switch (module) {
          case '专题展览':
            this.$router.push({name:'articleDetails', params: {id: id}})
            break;
          case '最新公告':
            this.$router.push({name:'newsDetail', query: {id:id,title:module}})
            break;
          case '国图新闻':
            this.$router.push({name:'newsDetail', query: {id:id,title:module}})
            break;
          case '征集启事':
            this.$router.push({name:'newsDetail', query: {id:id,title:module}})
            break;
          case '讲座预告':
            this.$router.push({name:'exhibitionDetail', query: {id:id,title:module,introduce:'讲座介绍'}})
            break;
          case '展览预告':
            this.$router.push({name:'exhibitionDetail', query: {id:id,title:module,introduce:'展览简介'}})
            break;
          case '演出预告':
            this.$router.push({name:'exhibitionDetail', query: {id:id,title:module,introduce:'演出简介'}})
            break;
          case '培训预告':
            this.$router.push({name:'exhibitionDetail', query: {id:id,title:module,introduce:'培训简介'}})
            break;
          case '文津经典诵读':
            request('get', '/nlc-web/api/poetryRead', {}, id).then(res => {
              this.$router.push({'name': 'poetryRead', query: {time: res.data.releaseDate,id:id, title:'文津经典诵读'}})
            })
            break;
          default:
            break;
        }
      }
    },
    onCal () {
      this.ifManagement = true
      this.checkAll = false
    },
    // 删除
    del () {
      console.log('choose',this.choose)
      if(this.choose.length===0){
        Toast.fail('请选择要删除的内容')
        return;
      }
      let params = {
        ids: []
      }
      for(let i=0;i<this.choose.length;i++){
        params.ids.push(this.choose[i].id)
      }
      params.ids = params.ids.join(",")
      console.log('params',params);
      request('post', '/nlc-web/api/collect/remove',params).then(res => {
        console.log('删除我的收藏', res)
        if(res.data==="success"){
          Toast.success('删除成功')
          location.reload()
        } else {
          Toast.fail('删除失败')
        }
      })
    }
  }
}
</script>

<style scoped>
.app-container{
  background:#ECF5FD;
  padding-top:.92rem;
}
.list{
  width:6.94rem;
  min-height:12.28rem;
  margin:.16rem .28rem;
  border-radius:8px;
  background:#fff;
}
.content{
  border-radius:8px;
  background: #fff;
}
.van-list{
  background:#fff;
  border-radius:8px;
}
.van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after{
  border-width:0 !important;
}
.list-title{
  font-family: SourceHanSerifCN-SemiBold;
  font-size:.36rem;
}
.management{
  color:#94979C;
  font-size:.3rem;
  font-family: SourceHanSansCN-Regular;
}
.del{
  color:#D31212;
  font-size:.3rem;
  font-family: SourceHanSansCN-Light;
}
.cal{
  color:#94979C;
  font-size:.3rem;
  font-family: SourceHanSansCN-Light;
  margin-left:.16rem;
}
.checkbox{
  display:inline-block;
}
.van-cell::after{
  border-bottom: 1px solid #B3BBC3;
}
.van-cell{
  border-radius:8px;
}
.no-list{
  width:6.94rem;
  height:12.28rem;
  background:#fff;
  border-radius:8px;
  margin:.17rem 0;
  font-size: .28rem;
  font-family: SourceHanSerifCN-Light;
  color: rgba(51, 51, 51, 0.4);
  text-align:center;
}
.no-list img{
  width:3.27rem;
  height:3.84rem;
  margin-top:3.8rem;
}
.module{
  position:absolute;
  right:.4rem;
}
>>>.van-cell-group{
  border-radius:8px 8px 0 0;
}
.title-size{
  font-size:.3rem;
}
.van-cell__label{
  font-size:.28rem;
}
</style>



// WEBPACK FOOTER //
// src/view/collection/index.vue